module.exports = __webpack_public_path__ + "static/media/xemelgo-logo.8d94c224.jpg";